import { combineReducers, applyMiddleware, legacy_createStore } from "redux";

import { homeReducer } from "./home/reducer";
import thunk from "redux-thunk";
import authreducer from "./auth/authreducer"
import productReducer from "../redux/prod/productReducer"


const rootReducer = combineReducers({
  
  homeReducer,
  authred:authreducer,
  productReducer:productReducer
  
});

const store = legacy_createStore(rootReducer, applyMiddleware(thunk));
store.subscribe(() => {
  console.log("Store changed", store.getState());
});
export {store};
